import { render } from "./ActivityFeedListed.vue?vue&type=template&id=8975d5d2"
import script from "./ActivityFeedListed.vue?vue&type=script&lang=js"
export * from "./ActivityFeedListed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__